const prospectingAgentStyles = `
@import url('https://fonts.googleapis.com/css2?family=Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,500;0,6..72,600;0,6..72,700;1,6..72,400&family=Inter:wght@400;450;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

.pa-app {
  --pa-bg: #f6f9fb;
  --pa-panel: #FFFFFF;
  --pa-soft: #edf1f5;
  --pa-hover: #e9eef3;
  --pa-sidebar: #edf1f5;
  --pa-ink: #2f3947;
  --pa-ink-2: #3e4957;
  --pa-ink-3: #4b5562;
  --pa-ink-4: #6b7c93;
  --pa-ink-5: #9baabe;
  --pa-line: #e4eaf0;
  --pa-line-2: #d3dae4;
  --pa-accent: #1d3d48;

  --pa-ok: #2F7A4E;
  --pa-warn: #B8702A;
  --pa-err: #B84A3E;
  --pa-info: #3B6BA8;

  --pa-serif: 'Newsreader', 'Iowan Old Style', Georgia, serif;
  --pa-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --pa-mono: 'JetBrains Mono', ui-monospace, Menlo, monospace;

  --pa-r-sm: 6px;
  --pa-r-md: 10px;
  --pa-r-lg: 14px;

  --pa-shadow-sm: 0 1px 2px rgba(15,30,45,0.04);
  --pa-shadow-md: 0 4px 16px rgba(15,30,45,0.06), 0 1px 2px rgba(15,30,45,0.04);
  --pa-shadow-lg: 0 24px 48px -12px rgba(15,30,45,0.14), 0 2px 6px rgba(15,30,45,0.04);

  display: grid;
  grid-template-columns: 248px 1fr;
  height: 100%;
  width: 100%;
  background: var(--pa-bg);
  color: var(--pa-ink);
  font-family: var(--pa-sans);
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
}

/* Sidebar */
.pa-sidebar {
  background: var(--pa-sidebar);
  border-right: 1px solid var(--pa-line);
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  gap: 4px;
  overflow-y: auto;
}

.pa-sidebar-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 8px 16px;
  border-bottom: 1px solid var(--pa-line);
  margin-bottom: 8px;
}

.pa-sidebar-header h2 {
  font-family: var(--pa-serif);
  font-size: 17px;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin: 0;
  color: var(--pa-ink);
  line-height: 1.1;
}

.pa-sidebar-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: linear-gradient(145deg, #182b35, #1d3d48);
  color: #e8f9f8;
  display: grid;
  place-items: center;
  font-family: var(--pa-serif);
  font-size: 16px;
  font-weight: 600;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.08);
  flex-shrink: 0;
}

.pa-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: var(--pa-r-sm);
  cursor: pointer;
  font-size: 13px;
  color: var(--pa-ink-3);
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  transition: background 0.12s, color 0.12s;
}

.pa-nav-item:hover {
  background: var(--pa-hover);
  color: var(--pa-ink);
}

.pa-nav-item--active {
  background: var(--pa-hover);
  color: var(--pa-ink);
  font-weight: 500;
}

/* Main content */
.pa-main {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* The company slide-over pins itself to this column, so the sidebar stays
     live beside it (WEB-10892). */
  position: relative;
}

.pa-topbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 16px;
  border-bottom: 1px solid var(--pa-line);
  flex-shrink: 0;
}

.pa-close-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid var(--pa-line);
  background: var(--pa-panel);
  color: var(--pa-ink-3);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: var(--pa-sans);
  transition: background 0.12s, color 0.12s, border-color 0.12s;
}

.pa-close-btn:hover {
  background: var(--pa-soft);
  color: var(--pa-ink);
  border-color: var(--pa-line-2);
}

.pa-main-inner {
  flex: 1;
  overflow-y: auto;
  padding: 24px 32px;
}

.pa-main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.pa-main-header h1 {
  font-family: var(--pa-serif);
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.015em;
  margin: 0;
  color: var(--pa-ink);
}

/* Run button */
.pa-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  border-radius: 999px;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: var(--pa-sans);
  transition: background 0.15s, box-shadow 0.15s;
}

.pa-btn--primary {
  background: var(--pa-accent);
  color: #e8f9f8;
  box-shadow: var(--pa-shadow-sm);
}

.pa-btn--primary:hover {
  background: #244a57;
}

.pa-btn--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Runs table */
.pa-runs-table {
  width: 100%;
  border-collapse: collapse;
}

.pa-runs-table th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: var(--pa-ink-4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--pa-line);
}

.pa-runs-table td {
  padding: 12px;
  border-bottom: 1px solid var(--pa-line);
  font-size: 13px;
  color: var(--pa-ink-2);
}

.pa-runs-table tr {
  cursor: pointer;
  transition: background 0.12s;
}

.pa-runs-table tbody tr:hover {
  background: var(--pa-hover);
}

.pa-runs-table tbody tr:active {
  background: var(--pa-soft);
}

/* Status badge */
.pa-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
}

.pa-status--completed { background: #E8F5E9; color: var(--pa-ok); }
.pa-status--running { background: #E3F2FD; color: var(--pa-info); }
.pa-status--pending { background: var(--pa-soft); color: var(--pa-ink-4); }
.pa-status--failed { background: #FFEBEE; color: var(--pa-err); }
.pa-status--partial { background: #FFF8E1; color: var(--pa-warn); }
.pa-status--cancelled { background: var(--pa-soft); color: var(--pa-ink-4); }

/* Cancel button */
.pa-btn-cancel {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: var(--pa-r-sm);
  border: 1px solid var(--pa-line);
  background: none;
  font-size: 11px;
  color: var(--pa-err);
  cursor: pointer;
  font-family: var(--pa-sans);
  transition: background 0.1s;
}

.pa-btn-cancel:hover {
  background: #FFEBEE;
}

.rh-cancel-hover {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  pointer-events: none;
  z-index: 2;
  background: var(--pa-panel);
  border: 1px solid var(--pa-line);
  box-shadow: var(--pa-shadow-sm);
  transition: opacity 0.15s;
}

.rh-row:hover .rh-cancel-hover {
  opacity: 1;
  pointer-events: auto;
}

/* Run detail */
.pa-run-detail {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.pa-run-detail-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pa-run-detail-header h1 {
  font-family: var(--pa-serif);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin: 0;
}

.pa-run-meta {
  display: flex;
  gap: 24px;
  padding: 16px;
  background: var(--pa-panel);
  border-radius: var(--pa-r-md);
  border: 1px solid var(--pa-line);
}

.pa-run-meta-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pa-run-meta-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--pa-ink-4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.pa-run-meta-value {
  font-size: 14px;
  font-weight: 500;
  color: var(--pa-ink);
}

/* Candidate card */
.pa-candidate-card {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  padding: 16px;
  background: var(--pa-panel);
  border-radius: var(--pa-r-md);
  border: 1px solid var(--pa-line);
  transition: box-shadow 0.1s;
}

.pa-candidate-card:hover {
  box-shadow: var(--pa-shadow-md);
}

.pa-candidate-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--pa-ink);
  margin: 0 0 4px;
}

.pa-candidate-meta {
  font-size: 12px;
  color: var(--pa-ink-3);
  display: flex;
  gap: 12px;
}

.pa-candidate-score {
  font-size: 20px;
  font-weight: 600;
  color: var(--pa-accent);
  align-self: center;
}

.pa-candidate-contacts {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pa-contact-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--pa-soft);
  font-size: 11px;
  color: var(--pa-ink-3);
}

.pa-candidates-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Search bar */
.pa-search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: var(--pa-panel);
  border: 1px solid var(--pa-line);
  border-radius: var(--pa-r-md);
  margin-bottom: 16px;
}

.pa-search-input {
  flex: 1;
  border: none;
  outline: none;
  background: none;
  font-size: 14px;
  font-family: var(--pa-sans);
  color: var(--pa-ink);
}

.pa-search-input::placeholder {
  color: var(--pa-ink-5);
}

.pa-search-explanation {
  padding: 8px 12px;
  background: var(--pa-soft);
  border-radius: var(--pa-r-sm);
  font-size: 12px;
  color: var(--pa-ink-3);
  margin-bottom: 16px;
  font-style: italic;
}

.pa-search-count {
  font-size: 13px;
  color: var(--pa-ink-3);
  margin-bottom: 12px;
  font-weight: 500;
}

/* Pagination */
.pa-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px 0;
}

.pa-pagination-info {
  font-size: 13px;
  color: var(--pa-ink-3);
}

/* Candidate card with checkbox */
.pa-candidate-card {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
  padding: 16px;
  background: var(--pa-panel);
  border-radius: var(--pa-r-md);
  border: 1px solid var(--pa-line);
  transition: box-shadow 0.1s, border-color 0.1s;
}

.pa-candidate-selected {
  border-color: var(--pa-accent);
  background: rgba(29, 61, 72, 0.03);
}

.pa-candidate-check {
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
}

.pa-candidate-check input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--pa-accent);
}

.pa-candidate-body {
  min-width: 0;
}

.pa-imported-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #E8F5E9;
  color: var(--pa-ok);
  font-size: 11px;
  font-weight: 500;
}

.pa-existing-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--pa-soft);
  color: var(--pa-ink-4);
  font-size: 11px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}

.pa-existing-badge:hover {
  background: var(--pa-hover);
  color: var(--pa-ink-3);
}

/* Candidates footer with select all + action */
.pa-candidates-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--pa-panel);
  border: 1px solid var(--pa-line);
  border-radius: var(--pa-r-md);
  margin-top: 8px;
  position: sticky;
  bottom: 0;
}

.pa-candidates-footer-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pa-candidates-footer-left input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--pa-accent);
}

.pa-footer-hint {
  font-size: 13px;
  color: var(--pa-ink-3);
}

.pa-empty {
  text-align: center;
  padding: 48px 24px;
  color: var(--pa-ink-4);
  font-size: 14px;
}

/* Loading */
.pa-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: var(--pa-ink-4);
}

/* Candidate table */
.pa-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.pa-table thead th {
  text-align: left;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--pa-ink-4);
  padding: 10px 12px;
  border-bottom: 1px solid var(--pa-line);
  background: var(--pa-soft);
}

.pa-table tbody tr {
  border-bottom: 1px solid var(--pa-line);
  transition: background 120ms ease;
  cursor: pointer;
}

.pa-table tbody tr:last-child {
  border-bottom: none;
}

.pa-table tbody tr:hover {
  background: var(--pa-hover);
}

.pa-table tbody tr.on {
  background: rgba(29, 61, 72, 0.05);
}

.pa-table td {
  padding: 10px 12px;
  vertical-align: top;
}

.pa-col-check {
  width: 30px;
  padding-right: 0 !important;
}

.pa-col-check input[type="checkbox"] {
  width: 15px;
  height: 15px;
  accent-color: var(--pa-accent);
  cursor: pointer;
}

.pa-col-score {
  width: 70px;
  text-align: right;
}

.pa-company-name {
  font-weight: 600;
  color: var(--pa-ink);
  font-size: 13px;
}

.pa-meta {
  font-size: 11.5px;
  color: var(--pa-ink-4);
  margin-top: 2px;
}

.pa-contact-name {
  font-size: 13px;
  color: var(--pa-ink);
  font-weight: 500;
}

/* Score chip */
/* The Match slot for a run that never scored: the design draws an empty
   dashed pill rather than a number (WEB-10894). */
.pa-score-none {
  display: inline-block;
  width: 38px;
  height: 16px;
  border: 1px dashed #cad2dd;
  border-radius: 999px;
}

.pa-score {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 22px;
  border-radius: var(--pa-r-sm);
  font-family: var(--pa-mono);
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  padding: 0 7px;
}

.pa-score-success {
  background: #E8F5E9;
  color: var(--pa-ok);
}

.pa-score-warn {
  background: #FFF8E1;
  color: var(--pa-warn);
}

.pa-score-muted {
  background: var(--pa-soft);
  color: var(--pa-ink-4);
}

/* Signal tags */
.pa-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  /* The table sizes its columns by content, so this is what keeps a long tag in its own column. */
  max-width: 260px;
}

.pa-signal-tag {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 500;
  line-height: 1.4;
  /* One line, cut at the column's edge: a long industry name ran into the next column. */
  white-space: nowrap;
  background: var(--pa-soft);
  color: var(--pa-ink-3);
}

.pa-signal-tag--high {
  background: #E8F5E9;
  color: var(--pa-ok);
}

.pa-signal-tag--medium {
  background: #E3F2FD;
  color: var(--pa-info);
}

.pa-signal-tag--warn {
  background: #FFF8E1;
  color: var(--pa-warn);
}

/* Dossier view */
.pa-dossier {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pa-dossier-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pa-dossier-header h2 {
  font-family: var(--pa-serif);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin: 0;
  color: var(--pa-ink);
}

.pa-dossier-meta {
  font-size: 12.5px;
  color: var(--pa-ink-3);
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.pa-dossier-meta a {
  color: var(--pa-accent);
  text-decoration: none;
}

.pa-dossier-meta a:hover {
  text-decoration: underline;
}

.pa-dossier-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: var(--pa-line);
  border: 1px solid var(--pa-line);
  border-radius: var(--pa-r-md);
  overflow: hidden;
}

.pa-sub-card {
  background: var(--pa-panel);
  padding: 14px 16px;
  min-height: 100px;
}

.pa-sub-card--full {
  grid-column: 1 / -1;
}

.pa-sub-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--pa-ink-4);
  margin-bottom: 10px;
}

.pa-prose {
  font-size: 13px;
  line-height: 1.6;
  color: var(--pa-ink-2);
  margin: 0;
}

.pa-talking-points {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pa-talking-points li {
  font-size: 13px;
  color: var(--pa-ink-2);
  padding-left: 16px;
  position: relative;
  line-height: 1.5;
}

.pa-talking-points li::before {
  content: '→';
  position: absolute;
  left: 0;
  color: var(--pa-accent);
  font-weight: 500;
}

.pa-contacts-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}

.pa-contacts-table th {
  text-align: left;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--pa-ink-4);
  padding: 6px 8px;
  border-bottom: 1px solid var(--pa-line);
}

.pa-contacts-table td {
  padding: 8px;
  border-bottom: 1px solid var(--pa-line);
  color: var(--pa-ink-2);
  vertical-align: top;
}

.pa-contacts-table tr:last-child td {
  border-bottom: none;
}

.pa-contacts-table .pa-contact-name {
  font-weight: 500;
  color: var(--pa-ink);
}

.pa-contact-channels {
  display: flex;
  gap: 8px;
  font-size: 11px;
}

.pa-contact-channels a {
  color: var(--pa-accent);
  text-decoration: none;
}

.pa-contact-channels a:hover {
  text-decoration: underline;
}

.pa-fin {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px 12px;
  font-size: 13px;
}

.pa-fin dt {
  color: var(--pa-ink-4);
  font-weight: 500;
}

.pa-fin dd {
  margin: 0;
  color: var(--pa-ink);
  font-family: var(--pa-mono);
  font-size: 12px;
}

.pa-provenance {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px 12px;
  font-size: 12px;
}

.pa-provenance dt {
  color: var(--pa-ink-4);
  font-weight: 500;
}

.pa-provenance dd {
  margin: 0;
  color: var(--pa-ink-3);
  font-family: var(--pa-mono);
  font-size: 11px;
  word-break: break-all;
}

.pa-crm-match {
  padding: 10px 12px;
  background: var(--pa-soft);
  border-radius: var(--pa-r-sm);
  font-size: 12.5px;
  color: var(--pa-ink-3);
}

.pa-crm-match a {
  color: var(--pa-accent);
  font-weight: 500;
  text-decoration: none;
}

.pa-crm-match a:hover {
  text-decoration: underline;
}

.pa-crm-match-warn {
  margin-top: 6px;
  font-size: 11.5px;
  color: var(--pa-warn);
  font-style: italic;
}

.pa-dossier-actions {
  display: flex;
  gap: 8px;
  padding-top: 8px;
}

.pa-dossier-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: var(--pa-ink-4);
  font-size: 13px;
}

.pa-source {
  margin-top: 8px;
  font-size: 10.5px;
  color: var(--pa-ink-5);
}

/* ===== Company Dossier (premium) ===== */

.dx {
  display: flex;
  flex-direction: column;
  max-width: 820px;
}

.dx-back {
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: none;
  color: var(--pa-ink-4);
  font-size: 12px;
  cursor: pointer;
  font-family: var(--pa-sans);
  padding: 0;
  margin-bottom: 12px;
}
.dx-back:hover { color: var(--pa-ink); }

/* Header */
.dx-header {
  display: grid;
  grid-template-columns: 64px 1fr auto;
  gap: 20px;
  align-items: flex-start;
  padding: 28px 0 24px;
  border-bottom: 1px solid var(--pa-line);
}
.dx-logo {
  width: 64px; height: 64px;
  border-radius: 12px;
  background: var(--pa-accent);
  color: #fff;
  display: grid; place-items: center;
  font-family: var(--pa-serif);
  font-size: 28px; font-weight: 500;
  letter-spacing: -0.01em;
}
.dx-meta { min-width: 0; }
.dx-name {
  font-family: var(--pa-serif);
  font-size: 28px; font-weight: 500;
  color: var(--pa-ink);
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin: 0 0 6px;
  display: flex; align-items: center; gap: 12px; flex-wrap: wrap;
}
.dx-name a {
  font-family: var(--pa-sans);
  font-size: 13px; font-weight: 400;
  color: var(--pa-info);
  text-decoration: none;
  letter-spacing: 0;
  display: inline-flex; align-items: center; gap: 4px;
}
.dx-name a:hover { text-decoration: underline; }
.dx-score-chip {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f0f7f3;
  color: var(--pa-ok);
  font-family: var(--pa-mono);
  font-size: 12px; font-weight: 600;
  border: 1px solid rgba(47, 122, 78, 0.2);
}
.dx-score--med { background: #faf3eb; color: var(--pa-warn); border-color: rgba(184, 112, 42, 0.2); }
.dx-score--low { background: #fbf0ee; color: var(--pa-err); border-color: rgba(184, 74, 62, 0.2); }
.dx-pills {
  display: flex; gap: 6px; flex-wrap: wrap;
  margin-top: 6px;
}
.dx-pill {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 3px 9px;
  border-radius: 999px;
  background: var(--pa-soft);
  color: var(--pa-ink-2);
  font-size: 11.5px; font-weight: 500;
  font-variant-numeric: tabular-nums;
}
.dx-pill svg { width: 11px; height: 11px; opacity: 0.7; }
.dx-actions {
  display: flex; flex-direction: column; gap: 6px;
  align-items: flex-end;
  flex-shrink: 0;
}
.dx-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 14px;
  border-radius: 999px;
  border: 1px solid var(--pa-line);
  background: var(--pa-panel);
  font-size: 13px; font-weight: 500;
  cursor: pointer;
  font-family: var(--pa-sans);
  color: var(--pa-ink-2);
  text-decoration: none;
  transition: background 0.12s;
  white-space: nowrap;
}
.dx-btn:hover { background: var(--pa-soft); }
.dx-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.dx-btn:disabled:hover { background: var(--pa-panel); }
.dx-btn-hint {
  max-width: 260px;
  font-size: 11.5px; line-height: 1.35;
  color: var(--pa-ink-4);
  text-align: right;
}
.dx-btn--primary {
  background: var(--pa-accent);
  color: #fff;
  border-color: var(--pa-accent);
}
.dx-btn--primary:hover { background: #163039; border-color: #163039; }

/* CRM banner */
.dx-crm-banner {
  display: flex; align-items: center; gap: 12px;
  margin-top: 20px; padding: 12px 16px;
  background: #eff3fa;
  border-left: 4px solid var(--pa-info);
  border-radius: 8px;
  font-size: 13px;
}
.dx-crm-banner--new {
  background: var(--pa-soft);
  border-left-color: var(--pa-ink-4);
}
.dx-crm-banner-icon {
  width: 28px; height: 28px;
  display: grid; place-items: center;
  border-radius: 8px;
  background: rgba(59, 107, 168, 0.12);
  color: var(--pa-info);
  flex-shrink: 0;
}
.dx-crm-banner--new .dx-crm-banner-icon {
  background: rgba(107, 124, 147, 0.15);
  color: var(--pa-ink-4);
}
.dx-crm-banner-text { flex: 1; color: var(--pa-ink-3); }
.dx-crm-banner-text strong { font-weight: 600; color: var(--pa-ink); }
.dx-crm-banner-text small { color: var(--pa-ink-4); display: block; margin-top: 2px; font-size: 11.5px; }
.dx-crm-banner-link {
  color: var(--pa-info);
  font-weight: 500;
  font-size: 12.5px;
  text-decoration: none;
  white-space: nowrap;
}
.dx-crm-banner-link:hover { text-decoration: underline; }

.dx-loading {
  display: flex; align-items: center; justify-content: center;
  min-height: 200px;
  color: var(--pa-ink-4); font-size: 13px;
}

/* Sections */
.dx-section { margin-top: 36px; }
.dx-section--split { display: grid; grid-template-columns: 1fr 1fr; gap: 36px; }
.dx-section-h {
  display: flex; align-items: baseline; gap: 12px;
  margin-bottom: 14px;
}
.dx-section-label {
  font-size: 10.5px; font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--pa-ink-4);
}
.dx-section-count {
  font-size: 11.5px; color: var(--pa-ink-4);
  font-variant-numeric: tabular-nums;
}

/* Prose */
.dx-prose {
  font-size: 14.5px; line-height: 1.7;
  color: var(--pa-ink-2);
  margin: 0;
}
.dx-prose--empty { font-style: italic; color: var(--pa-ink-4); }

/* Talking points */
.dx-bullets { display: flex; flex-direction: column; gap: 10px; margin: 0; padding: 0; list-style: none; }
.dx-bullet {
  display: flex; gap: 10px;
  padding-left: 4px;
}
.dx-bullet-icon {
  width: 18px; height: 18px;
  flex-shrink: 0;
  display: grid; place-items: center;
  color: var(--pa-accent);
  margin-top: 2px;
}
.dx-bullet-body {
  font-size: 14px; line-height: 1.6;
  color: var(--pa-ink-2);
  flex: 1;
}

/* Financials strip */
.dx-fin-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1px;
  background: var(--pa-line);
  border: 1px solid var(--pa-line);
  border-radius: 10px;
  overflow: hidden;
}
.dx-fin {
  background: var(--pa-panel);
  padding: 14px 18px;
}
.dx-fin-v {
  font-family: var(--pa-serif);
  font-size: 22px; font-weight: 500;
  color: var(--pa-ink);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
}
.dx-fin-l {
  font-size: 10.5px; font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--pa-ink-4);
  margin-top: 4px;
}
.dx-fin-v--up { color: var(--pa-ok); }

/* Signal cards */
.dx-signals { display: flex; flex-direction: column; gap: 10px; }
.dx-signal {
  padding: 14px 18px;
  border-radius: 10px;
  border-left: 4px solid var(--pa-info);
  background: #eff3fa;
  display: grid;
  grid-template-columns: 28px 1fr auto;
  gap: 12px;
  align-items: flex-start;
}
.dx-signal--positive { border-left-color: var(--pa-ok); background: #f0f7f3; }
.dx-signal--positive .dx-signal-icon { color: var(--pa-ok); }
.dx-signal--warn { border-left-color: var(--pa-warn); background: #faf3eb; }
.dx-signal--warn .dx-signal-icon { color: var(--pa-warn); }
.dx-signal--risk { border-left-color: var(--pa-err); background: #fbf0ee; }
.dx-signal--risk .dx-signal-icon { color: var(--pa-err); }
.dx-signal-icon {
  width: 24px; height: 24px;
  display: grid; place-items: center;
  color: var(--pa-info);
  margin-top: 1px;
}
.dx-signal-body { min-width: 0; }
.dx-signal-head {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  margin-bottom: 4px;
}
.dx-signal-type {
  display: inline-flex;
  padding: 2px 7px;
  border-radius: 4px;
  background: rgba(255,255,255,0.6);
  font-size: 10px; font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: inherit;
}
.dx-signal--positive .dx-signal-type { color: var(--pa-ok); }
.dx-signal--warn .dx-signal-type { color: var(--pa-warn); }
.dx-signal--risk .dx-signal-type { color: var(--pa-err); }
.dx-signal-title {
  font-size: 14px; font-weight: 600;
  color: var(--pa-ink);
  line-height: 1.35;
}
.dx-signal-summary {
  font-size: 13px; line-height: 1.55;
  color: var(--pa-ink-2);
  margin: 4px 0 6px;
}
.dx-signal-foot {
  display: flex; align-items: center; gap: 8px;
  font-size: 11.5px; color: var(--pa-ink-4);
}
.dx-signal-foot a { color: var(--pa-info); text-decoration: none; }
.dx-signal-foot a:hover { text-decoration: underline; }
.dx-conf {
  display: inline-flex; align-items: center; gap: 3px;
  font-size: 10.5px; font-weight: 600;
  color: var(--pa-ink-4);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.dx-signal-date {
  font-family: var(--pa-mono);
  font-size: 11px;
  color: var(--pa-ink-4);
  white-space: nowrap;
  align-self: flex-start;
  margin-top: 2px;
}

/* Contact cards */
.dx-contacts {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 10px;
}
.dx-contact {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--pa-line);
  border-radius: 10px;
  background: var(--pa-panel);
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.dx-contact:hover {
  border-color: rgba(29, 61, 72, 0.3);
  box-shadow: 0 1px 3px rgba(47, 57, 71, 0.08);
}
.dx-contact--primary {
  border-color: rgba(29, 61, 72, 0.3);
  background: linear-gradient(to right, rgba(29,61,72,0.025), transparent 40%);
}
.dx-contact-av {
  width: 36px; height: 36px;
  border-radius: 50%;
  display: grid; place-items: center;
  color: #fff;
  font-size: 12.5px; font-weight: 600;
  flex-shrink: 0;
}
.dx-contact-body { flex: 1; min-width: 0; }
.dx-contact-pick { align-self: flex-start; flex-shrink: 0; margin: 2px 0 0; cursor: pointer; }
.dx-contact-name {
  font-size: 13.5px; font-weight: 600;
  color: var(--pa-ink);
  display: flex; align-items: center; gap: 6px;
}
.dx-contact-primary-tag {
  font-size: 9px; font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--pa-accent);
  background: rgba(29, 61, 72, 0.08);
  padding: 1px 5px;
  border-radius: 3px;
}
.dx-contact-role {
  font-size: 11.5px; color: var(--pa-ink-4);
  margin-top: 2px;
  display: flex; align-items: center; gap: 6px;
}
.dx-contact-source {
  font-size: 10.5px; font-weight: 500;
  color: var(--pa-ink-4);
}
.dx-channel-source {
  font-size: 8.5px; font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--pa-accent);
  background: rgba(29, 61, 72, 0.10);
  padding: 0 3px;
  border-radius: 2px;
}
.dx-contact-channels {
  display: flex; gap: 4px;
  margin-top: 6px;
}
.dx-channel-pill {
  display: inline-flex; align-items: center; gap: 3px;
  padding: 2px 6px;
  border-radius: 999px;
  background: var(--pa-soft);
  color: var(--pa-ink-2);
  font-size: 10.5px; font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  border: none;
  font-family: var(--pa-sans);
}
.dx-channel-pill:hover { background: rgba(29, 61, 72, 0.08); color: var(--pa-accent); }
.dx-channel-pill svg { width: 10px; height: 10px; }

/* Chip list */
.dx-chip-list { display: flex; flex-wrap: wrap; gap: 6px; }
.dx-chip {
  padding: 5px 11px;
  background: var(--pa-soft);
  border-radius: 999px;
  font-size: 12px;
  color: var(--pa-ink-2);
}

/* Generated footer */
.dx-meta-footer {
  margin-top: 20px;
  padding-top: 14px;
  border-top: 1px dashed var(--pa-line);
  font-size: 11.5px; color: var(--pa-ink-4);
  display: flex; align-items: center; gap: 14px;
  flex-wrap: wrap;
}
.dx-meta-footer code {
  font-family: var(--pa-mono);
  font-size: 11px;
  background: var(--pa-soft);
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--pa-ink-2);
}

/* ===== Run List Rows ===== */

.rh-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rh-row {
  display: grid;
  grid-template-columns: 12px 1fr 90px 90px 90px;
  gap: 14px;
  align-items: center;
  padding: 12px 16px;
  background: var(--pa-panel);
  border: 1px solid var(--pa-line);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.12s ease, box-shadow 0.15s ease, background 0.12s ease;
  position: relative;
}

.rh-row:hover {
  background: var(--pa-soft);
  box-shadow: var(--pa-shadow-md);
  border-color: rgba(29, 61, 72, 0.18);
}

.rh-row.selected {
  border-color: var(--pa-accent);
  box-shadow: 0 0 0 1px rgba(29, 61, 72, 0.15);
}

/* Inline detail (expands below selected row) */
.rh-inline-detail {
  border: 1px solid var(--pa-line);
  border-top: none;
  border-radius: 0 0 10px 10px;
  background: var(--pa-panel);
  margin-top: -6px;
  margin-bottom: 6px;
  overflow: hidden;
}

.rh-inline-detail .rh-detail-head {
  grid-template-columns: auto 1fr auto;
  padding: 16px 18px 14px;
  align-items: center;
}

.rh-inline-detail .rh-detail-h {
  font-size: 18px;
  margin: 0;
}

.rh-inline-detail .rh-stats {
  grid-template-columns: repeat(3, 1fr);
}

.rh-inline-detail .rh-stat { padding: 10px 18px; }
.rh-inline-detail .rh-stat-v { font-size: 18px; }

.rh-inline-body {
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rh-row-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--pa-ink-4);
}
.rh-row-dot.completed { background: var(--pa-ok); }
.rh-row-dot.running {
  background: var(--pa-info);
  animation: rh-pulse 1.6s ease-in-out infinite;
}
.rh-row-dot.failed { background: var(--pa-err); }
.rh-row-dot.partial { background: var(--pa-warn); }

@keyframes rh-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

.rh-row-id {
  font-family: var(--pa-mono);
  font-size: 12px;
  color: var(--pa-ink-4);
}
.rh-row-id strong { color: var(--pa-ink); font-weight: 600; }

.rh-row-main { min-width: 0; }

.rh-row-title {
  font-family: var(--pa-serif);
  font-size: 15px;
  font-weight: 500;
  color: var(--pa-ink);
  letter-spacing: -0.005em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rh-row-summary {
  font-size: 11.5px;
  color: var(--pa-ink-4);
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rh-row-num {
  font-family: var(--pa-mono);
  font-size: 12px;
  color: var(--pa-ink);
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.rh-row-num span {
  display: block;
  font-size: 9.5px;
  font-family: var(--pa-sans);
  color: var(--pa-ink-4);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 600;
  margin-top: 1px;
}

/* ===== Run Detail (premium) ===== */

.rh-detail {
  background: var(--pa-panel);
  border: 1px solid var(--pa-line);
  border-radius: 12px;
  overflow: hidden;
}

.rh-detail-head {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 16px;
  align-items: flex-start;
  padding: 22px 24px 18px;
  border-bottom: 1px solid var(--pa-line);
}
.rh-detail-head-meta { min-width: 0; }
.rh-detail-badges {
  display: flex; gap: 8px; align-items: center; flex-wrap: wrap;
  margin-bottom: 8px;
}
.rh-detail-h {
  font-family: var(--pa-serif);
  font-size: 22px; font-weight: 500;
  color: var(--pa-ink);
  letter-spacing: -0.015em;
  margin: 0 0 4px;
  line-height: 1.2;
}
.rh-detail-sub {
  font-size: 12.5px; color: var(--pa-ink-4);
  display: flex; gap: 10px; flex-wrap: wrap;
}
.rh-detail-sub code {
  font-family: var(--pa-mono);
  font-size: 11px;
  background: var(--pa-soft);
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--pa-ink-2);
}

/* Stats strip */
.rh-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1px;
  background: var(--pa-line);
}
.rh-stat {
  background: var(--pa-panel);
  padding: 14px 18px;
}
.rh-stat-v {
  font-family: var(--pa-serif);
  font-size: 22px; font-weight: 500;
  color: var(--pa-ink);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
}
.rh-stat-l {
  font-size: 10.5px; font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--pa-ink-4);
  margin-top: 4px;
}

/* Detail body */
.rh-detail-body {
  padding: 22px 24px 24px;
  display: flex; flex-direction: column; gap: 22px;
}

/* Query card */
.rh-query-card {
  padding: 14px 18px;
  border-left: 4px solid var(--pa-info);
  background: #eff3fa;
  border-radius: 8px;
}
.rh-query-label {
  font-size: 10.5px; font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--pa-info);
  margin-bottom: 6px;
}
.rh-query-body {
  font-family: var(--pa-serif);
  font-size: 15px;
  font-style: italic;
  line-height: 1.55;
  color: var(--pa-ink);
  margin: 0;
}

/* Pipeline rail */
.rh-pipeline {
  background: var(--pa-soft);
  border-radius: 10px;
  padding: 16px 20px 18px;
}
.rh-pipeline-track {
  position: relative;
  height: 4px;
  background: var(--pa-line);
  border-radius: 2px;
  margin: 12px 0 14px;
}
.rh-pipeline-fill {
  height: 100%;
  background: var(--pa-accent);
  border-radius: 2px;
  transition: width 400ms ease;
}
.rh-pipeline-steps {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: 8px;
}
.rh-pipeline-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: none; border: none; padding: 4px;
  text-align: center;
  font-family: var(--pa-sans);
  min-width: 0;
}
.rh-pipeline-dot {
  width: 24px; height: 24px;
  border-radius: 50%;
  background: var(--pa-panel);
  border: 1.5px solid var(--pa-line);
  display: grid; place-items: center;
  font-family: var(--pa-mono);
  font-size: 11px; font-weight: 600;
  color: var(--pa-ink-4);
  font-variant-numeric: tabular-nums;
}
.rh-pipeline-step.completed .rh-pipeline-dot {
  background: var(--pa-ok); border-color: var(--pa-ok); color: #fff;
}
.rh-pipeline-step.running .rh-pipeline-dot {
  background: var(--pa-info); border-color: var(--pa-info); color: #fff;
  box-shadow: 0 0 0 4px rgba(59, 107, 168, 0.16);
}
.rh-pipeline-step.failed .rh-pipeline-dot {
  background: var(--pa-err); border-color: var(--pa-err); color: #fff;
}
.rh-pipeline-step.pending .rh-pipeline-dot { border-style: dashed; }
.rh-pipeline-label {
  font-size: 10px;
  color: var(--pa-ink-4);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis;
  max-width: 100%;
  font-weight: 600;
}
.rh-pipeline-step.completed .rh-pipeline-label,
.rh-pipeline-step.running .rh-pipeline-label { color: var(--pa-ink); }
.rh-pipeline-time {
  font-family: var(--pa-mono);
  font-size: 9.5px;
  color: var(--pa-ink-4);
  margin-top: 1px;
}

/* Agentic actions */
.rh-actions { display: flex; flex-direction: column; gap: 8px; }
.rh-action {
  display: grid;
  grid-template-columns: 24px 1fr auto;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  background: var(--pa-panel);
  border: 1px solid var(--pa-line);
}
.rh-action.reasoning {
  background: #eff3fa;
  border-color: rgba(59, 107, 168, 0.18);
}
.rh-action-icon {
  width: 22px; height: 22px;
  display: grid; place-items: center;
  border-radius: 50%;
  flex-shrink: 0;
}
.rh-action.tool .rh-action-icon { background: var(--pa-soft); color: var(--pa-ink-2); }
.rh-action.reasoning .rh-action-icon { background: rgba(59, 107, 168, 0.15); color: var(--pa-info); }
.rh-action-body { min-width: 0; }
.rh-action-head {
  display: flex; align-items: baseline; gap: 8px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}
.rh-action-kind {
  font-size: 9.5px; font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--pa-ink-4);
}
.rh-action.reasoning .rh-action-kind { color: var(--pa-info); }
.rh-action-name {
  font-family: var(--pa-mono);
  font-size: 12px; font-weight: 500;
  color: var(--pa-ink);
}
.rh-action-text {
  font-family: var(--pa-serif);
  font-size: 13.5px;
  font-style: italic;
  line-height: 1.55;
  color: var(--pa-ink-2);
  margin: 0;
}
.rh-action-io {
  display: grid;
  grid-template-columns: 50px 1fr;
  gap: 8px;
  margin-top: 6px;
  font-family: var(--pa-mono);
  font-size: 11px;
}
.rh-action-io dt {
  color: var(--pa-ink-4);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 9.5px;
  font-family: var(--pa-sans);
  font-weight: 700;
  padding-top: 3px;
}
.rh-action-io dd {
  margin: 0;
  background: var(--pa-soft);
  padding: 4px 8px;
  border-radius: 4px;
  color: var(--pa-ink-2);
  overflow-wrap: anywhere;
  line-height: 1.5;
}
.rh-action-dur {
  font-family: var(--pa-mono);
  font-size: 11px;
  color: var(--pa-ink-4);
  white-space: nowrap;
  align-self: flex-start;
  padding-top: 1px;
}

/* Final summary */
.rh-summary {
  padding: 18px 22px;
  border-radius: 10px;
  background: var(--pa-soft);
  border-left: 4px solid var(--pa-info);
}
.rh-summary-label {
  font-size: 10.5px; font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--pa-info);
  margin-bottom: 8px;
}
.rh-summary-body {
  font-size: 14px;
  line-height: 1.65;
  color: var(--pa-ink-2);
  margin: 0;
  white-space: pre-line;
}
.rh-summary-toggle {
  margin-top: 8px;
  padding: 0;
  background: none;
  border: none;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--pa-info);
  cursor: pointer;
}
.rh-summary-toggle:hover { text-decoration: underline; }

/* Status pill for run detail */
.rh-status-pill {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 10.5px; font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
  justify-self: end;
}
.rh-status-pill.completed { background: #E8F5E9; color: var(--pa-ok); }
.rh-status-pill.running { background: #E3F2FD; color: var(--pa-info); }
.rh-status-pill.failed { background: rgba(184, 74, 62, 0.1); color: var(--pa-err); }
.rh-status-pill.partial { background: #FFF8E1; color: var(--pa-warn); }
.rh-status-pill.pending { background: var(--pa-soft); color: var(--pa-ink-4); }

/* Top candidates preview */
.rh-cands { display: flex; flex-direction: column; gap: 8px; }
.rh-cand-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 14px;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid var(--pa-line);
  border-radius: 8px;
  background: var(--pa-panel);
  cursor: pointer;
  transition: background 0.12s ease;
}
.rh-cand-row:hover { background: var(--pa-soft); }
.rh-cand-main { min-width: 0; }
.rh-cand-name {
  font-family: var(--pa-serif);
  font-size: 14.5px; font-weight: 500;
  color: var(--pa-ink);
  letter-spacing: -0.005em;
}
.rh-cand-meta {
  font-size: 11.5px; color: var(--pa-ink-4);
  margin-top: 2px;
}
.rh-cand-signals {
  display: flex; flex-wrap: wrap; gap: 4px;
  margin-top: 6px;
}
.rh-cand-sig {
  padding: 2px 7px;
  border-radius: 4px;
  background: var(--pa-soft);
  font-size: 10.5px;
  color: var(--pa-ink-2);
}
.rh-cand-score {
  font-family: var(--pa-mono);
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  padding: 3px 9px;
  border-radius: 4px;
}
.rh-cand-score.high { background: #E8F5E9; color: var(--pa-ok); }
.rh-cand-score.med { background: #FFF8E1; color: var(--pa-warn); }
.rh-cand-score.low { background: var(--pa-soft); color: var(--pa-ink-4); }

/* Keep legacy keyframes (deduplicated) */
@keyframes rh-pulse-legacy {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

/* ===== Run Cards ===== */

.pa-run-cards {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pa-run-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  background: var(--pa-panel);
  border: 1px solid var(--pa-line);
  border-radius: var(--pa-r-md);
  cursor: pointer;
  transition: box-shadow 0.12s, border-color 0.12s;
}

.pa-run-card:hover {
  box-shadow: var(--pa-shadow-md);
  border-color: var(--pa-line-2);
}

.pa-run-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pa-agent-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.pa-agent-badge--full {
  background: rgba(29, 61, 72, 0.08);
  color: var(--pa-accent);
}

.pa-agent-badge--agentic {
  background: rgba(59, 107, 168, 0.08);
  color: var(--pa-info);
}

.pa-agent-badge--sourcing {
  background: rgba(184, 112, 42, 0.08);
  color: var(--pa-warn);
}

.pa-run-card-id {
  font-size: 12px;
  font-family: var(--pa-mono);
  color: var(--pa-ink-4);
}

.pa-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  margin-left: auto;
}

.pa-status-pill--completed { background: #E8F5E9; color: var(--pa-ok); }
.pa-status-pill--running { background: #E3F2FD; color: var(--pa-info); }
.pa-status-pill--pending { background: var(--pa-soft); color: var(--pa-ink-4); }
.pa-status-pill--failed { background: #FFEBEE; color: var(--pa-err); }
.pa-status-pill--partial { background: #FFF8E1; color: var(--pa-warn); }
.pa-status-pill--cancelled { background: var(--pa-soft); color: var(--pa-ink-4); }

.pa-run-card-query {
  font-size: 13px;
  color: var(--pa-ink-2);
  font-style: italic;
  padding-left: 2px;
}

.pa-run-card-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--pa-ink-4);
}

.pa-run-card-sep {
  opacity: 0.5;
}

.pa-run-card-duration {
  font-family: var(--pa-mono);
  font-variant-numeric: tabular-nums;
}

/* ===== Explore Dashboard ===== */

.pa-explore {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.pa-explore-hero {
  text-align: center;
  padding: 32px 24px 28px;
}

.pa-explore-title {
  font-family: var(--pa-serif);
  font-size: 28px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: var(--pa-ink);
  margin: 0 0 6px;
}

.pa-explore-subtitle {
  font-size: 14px;
  color: var(--pa-ink-4);
  margin: 0 0 20px;
  line-height: 1.5;
}

.pa-explore-search {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 680px;
  margin: 0 auto;
  padding: 10px 10px 10px 16px;
  background: var(--pa-panel);
  border: 1px solid var(--pa-line);
  border-radius: 999px;
  box-shadow: var(--pa-shadow-md);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.pa-explore-search:focus-within {
  border-color: var(--pa-accent);
  box-shadow: var(--pa-shadow-md), 0 0 0 3px rgba(29,61,72,0.08);
}

.pa-explore-search-icon {
  width: 18px;
  height: 18px;
  color: var(--pa-ink-4);
  flex-shrink: 0;
}

.pa-explore-search-input {
  flex: 1;
  border: none;
  outline: none;
  background: none;
  font-size: 14px;
  font-family: var(--pa-sans);
  color: var(--pa-ink);
  min-width: 0;
}

.pa-explore-search-input::placeholder {
  color: var(--pa-ink-5);
}

/* AI explanation banner */
.pa-explore-explanation {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 4px;
  padding: 10px 16px;
  background: rgba(29,61,72,0.04);
  border-left: 3px solid var(--pa-accent);
  font-size: 13px;
  color: var(--pa-ink-3);
  line-height: 1.5;
}

.pa-explore-explanation em {
  color: var(--pa-ink-2);
  font-style: normal;
  font-weight: 500;
}

/* Tabs */
.pa-explore-tabs {
  display: flex;
  gap: 0;
  border-bottom: 1px solid var(--pa-line);
  padding: 0 4px;
  margin-bottom: 0;
}

.pa-explore-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border: none;
  background: none;
  font-size: 13px;
  font-weight: 500;
  color: var(--pa-ink-4);
  cursor: pointer;
  font-family: var(--pa-sans);
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.12s, border-color 0.12s;
}

.pa-explore-tab:hover {
  color: var(--pa-ink-2);
}

.pa-explore-tab--active {
  color: var(--pa-accent);
  border-bottom-color: var(--pa-accent);
}

.pa-explore-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--pa-soft);
  font-size: 10.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--pa-ink-3);
}

.pa-explore-tab--active .pa-explore-tab-count {
  background: rgba(29,61,72,0.1);
  color: var(--pa-accent);
}

/* Loading */
.pa-explore-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 64px 24px;
  color: var(--pa-ink-4);
  font-size: 14px;
}

.pa-explore-loading-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--pa-info);
  animation: pa-pulse 1.2s ease-in-out infinite;
}

@keyframes pa-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.3; transform: scale(1.5); }
}

/* Empty state */
.pa-explore-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 64px 24px;
  color: var(--pa-ink-4);
  text-align: center;
}

.pa-explore-empty p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.pa-explore-empty-sub {
  font-size: 13px !important;
  color: var(--pa-ink-5) !important;
}

/* Selection bar */
.pa-explore-selection-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: var(--pa-accent);
  color: #e8f9f8;
  border-radius: var(--pa-r-md);
  margin-top: 8px;
  position: sticky;
  bottom: 16px;
  box-shadow: var(--pa-shadow-lg);
  animation: pa-slide-up 0.2s ease;
}

@keyframes pa-slide-up {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.pa-explore-selection-count {
  font-size: 13px;
}

.pa-explore-selection-bar .pa-btn--primary {
  background: rgba(255,255,255,0.15);
  color: white;
  border: 1px solid rgba(255,255,255,0.2);
}

.pa-explore-selection-bar .pa-btn--primary:hover {
  background: rgba(255,255,255,0.25);
}

/* CRM match actions */
.pa-crm-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
}

.pa-match-tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.pa-match-tag--org {
  background: #E8F5E9;
  color: var(--pa-ok);
}

.pa-match-tag--domain {
  background: #FFF8E1;
  color: var(--pa-warn);
}

.pa-match-tag--name {
  background: #ECEFF1;
  color: var(--pa-ink-4);
}

.pa-sync-btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid var(--pa-line);
  background: var(--pa-panel);
  font-size: 10.5px;
  font-weight: 500;
  color: var(--pa-accent);
  cursor: pointer;
  font-family: var(--pa-sans);
  transition: background 0.12s, border-color 0.12s;
}

.pa-sync-btn:hover {
  background: var(--pa-soft);
  border-color: var(--pa-accent);
}

.pa-sync-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pa-sync-btn--new {
  color: var(--pa-ink-3);
}

.pa-sync-btn--new:hover {
  color: var(--pa-ink);
}

/* ===== Corporate Groups ===== */

.pa-groups {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 0;
}

.pa-group-card {
  border: 1px solid var(--pa-line);
  border-radius: var(--pa-r-md);
  background: var(--pa-panel);
  overflow: hidden;
}

.pa-group-header {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  cursor: pointer;
  font-family: var(--pa-sans);
  text-align: left;
  transition: background 0.12s;
}

.pa-group-header:hover {
  background: var(--pa-soft);
}

.pa-group-chev {
  color: var(--pa-ink-4);
  flex-shrink: 0;
  transition: transform 0.15s;
}

.pa-group-chev--open {
  transform: rotate(90deg);
}

.pa-group-header-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.pa-group-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--pa-ink);
}

.pa-group-meta {
  font-size: 12px;
  color: var(--pa-ink-4);
}

.pa-group-meta strong {
  color: var(--pa-accent);
}

.pa-group-revenue {
  font-size: 12px;
  font-family: var(--pa-mono);
  color: var(--pa-ink-3);
  white-space: nowrap;
}

.pa-group-body {
  border-top: 1px solid var(--pa-line);
  padding: 8px 16px 12px 42px;
}

.pa-group-section {
  margin-bottom: 8px;
}

.pa-group-section:last-child {
  margin-bottom: 0;
}

.pa-group-section-label {
  font-size: 10.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--pa-ink-4);
  padding: 6px 0 4px;
}

.pa-group-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid var(--pa-line);
}

.pa-group-row:last-child {
  border-bottom: none;
}

.pa-group-row--clickable {
  cursor: pointer;
  transition: background 0.12s;
  border-radius: var(--pa-r-sm);
  padding-left: 8px;
  padding-right: 8px;
  margin-left: -8px;
  margin-right: -8px;
}
.pa-group-row--clickable:hover {
  background: var(--pa-hover);
}

.pa-group-row svg {
  margin-top: 2px;
  flex-shrink: 0;
}

.pa-group-row--customer a {
  color: var(--pa-accent);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
}

.pa-group-row--customer a:hover {
  text-decoration: underline;
}

.pa-group-row-body {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

/* Settings */
.pa-settings {
  max-width: 880px;
}

.pa-settings-empty {
  font-size: 13.5px;
  line-height: 1.6;
  color: var(--pa-ink-4);
  background: var(--pa-panel);
  border: 1px dashed var(--pa-line-2);
  border-radius: var(--pa-r-md);
  padding: 24px 28px;
}

.pa-settings-hint {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  padding: 10px 14px;
  font-size: 12.5px;
  color: var(--pa-info);
  background: #eef4fb;
  border: 1px solid #d8e4f1;
  border-radius: var(--pa-r-sm);
}

/* Connectors */
.pa-connectors {}

.pa-connector-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-top: 6px;
}

@media (max-width: 900px) {
  .pa-connector-list { grid-template-columns: 1fr; }
}

.pa-connector-card {
  background: var(--pa-panel);
  border: 1px solid var(--pa-line);
  border-radius: var(--pa-r-md);
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: var(--pa-shadow-sm);
}

.pa-connector-head {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pa-connector-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--pa-ink);
  font-weight: 500;
}

.pa-connector-name {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.005em;
}

.pa-connector-used-for {
  font-size: 11.5px;
  color: var(--pa-ink-4);
  letter-spacing: 0.01em;
}

.pa-connector-desc {
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--pa-ink-3);
  margin: 0;
}

.pa-connector-current {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  padding: 6px 10px;
  background: var(--pa-soft);
  border-radius: var(--pa-r-sm);
}

.pa-connector-current code {
  font-family: var(--pa-mono);
  font-size: 11.5px;
  color: var(--pa-ink-2);
  letter-spacing: 0.04em;
}

.pa-connector-actions {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.pa-connector-validate {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  font-size: 11.5px;
  font-weight: 500;
  color: var(--pa-ink-2);
  background: var(--pa-bg);
  border: 1px solid var(--pa-line-2);
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s, color 0.12s;
}
.pa-connector-validate:hover { background: var(--pa-hover); border-color: var(--pa-line-3); color: var(--pa-ink); }
.pa-connector-validate:disabled { opacity: 0.6; cursor: wait; }

.pa-connector-remove {
  background: none;
  border: none;
  color: var(--pa-ink-4);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  transition: color 0.12s, background 0.12s;
}

.pa-connector-remove:hover {
  color: var(--pa-err);
  background: var(--pa-hover);
}

.pa-connector-validated-at {
  font-size: 11px;
  color: var(--pa-ink-4);
  padding: 0 2px;
}

.pa-connector-inherited {
  font-size: 12px;
  color: var(--pa-ink-4);
  padding: 6px 10px;
  background: var(--pa-soft);
  border-radius: var(--pa-r-sm);
}

.pa-connector-input-row {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.pa-connector-input {
  flex: 1;
  padding: 7px 10px;
  font-size: 13px;
  font-family: var(--pa-mono);
  color: var(--pa-ink);
  background: var(--pa-bg);
  border: 1px solid var(--pa-line-2);
  border-radius: var(--pa-r-sm);
  outline: none;
  transition: border-color 0.12s;
}

.pa-connector-input:focus {
  border-color: var(--pa-accent);
}

.pa-connector-error {
  font-size: 12px;
  color: var(--pa-err);
}

.pa-status--failed { background: #fdecea; color: var(--pa-err); }

/* ──────────────────────────────────────────────────────────────────────
 * Settings scope ribbon (shared across Connectors, Prompts, ICP tabs)
 * ──────────────────────────────────────────────────────────────────── */
.pa-scope-ribbon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  margin: 18px 0 14px;
  background: var(--pa-soft);
  border: 1px solid var(--pa-line);
  border-radius: var(--pa-r-md);
}

.pa-scope-ribbon__label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: var(--pa-ink-2);
  min-width: 0;
}

.pa-scope-ribbon__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--pa-ink);
  letter-spacing: -0.005em;
}

.pa-scope-ribbon__meta {
  margin-top: 2px;
  font-size: 11.5px;
  color: var(--pa-ink-3);
  line-height: 1.45;
  max-width: 540px;
}

.pa-scope-seg {
  display: inline-flex;
  background: var(--pa-bg);
  border: 1px solid var(--pa-line-2);
  border-radius: var(--pa-r-sm);
  padding: 2px;
}

.pa-scope-seg__opt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  color: var(--pa-ink-3);
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  transition: background 0.12s, color 0.12s;
}
.pa-scope-seg__opt:hover { color: var(--pa-ink); }
.pa-scope-seg__opt--active {
  background: var(--pa-panel);
  color: var(--pa-ink);
  box-shadow: 0 1px 2px rgba(20, 24, 32, 0.06);
}
.pa-scope-seg__dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: var(--pa-accent);
  border-radius: 999px;
}

.pa-connector-cta {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--pa-ink-2);
  background: var(--pa-bg);
  border: 1px solid var(--pa-line-2);
  border-radius: var(--pa-r-sm);
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s, color 0.12s;
}
.pa-connector-cta:hover { background: var(--pa-hover); border-color: var(--pa-line-3); color: var(--pa-ink); }
.pa-connector-cta:disabled { opacity: 0.5; cursor: not-allowed; }

/* ──────────────────────────────────────────────────────────────────────
 * Workspace-links banner — links from PA settings to the AI Workspace
 * settings (Connections + Knowledge) that own connectors and prompts now.
 * ──────────────────────────────────────────────────────────────────── */
.pa-workspace-links {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
}
.pa-workspace-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: var(--pa-bg);
  border: 1px solid var(--pa-line-2);
  border-radius: var(--pa-r-sm);
  color: var(--pa-ink);
  text-decoration: none;
  transition: background 0.12s, border-color 0.12s;
}
.pa-workspace-link:hover {
  background: var(--pa-hover);
  border-color: var(--pa-line-3);
}
.pa-workspace-link__title {
  font-weight: 500;
  font-size: 13.5px;
  color: var(--pa-ink);
}
.pa-workspace-link__meta {
  font-size: 12px;
  color: var(--pa-ink-2);
  margin-top: 2px;
}
@media (max-width: 720px) {
  .pa-workspace-links { grid-template-columns: 1fr; }
}

/* ──────────────────────────────────────────────────────────────────────
 * Shared small primitives reused across Prompts and ICP tabs.
 * ──────────────────────────────────────────────────────────────────── */
.pa-link {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: var(--pa-accent);
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: text-decoration-color 0.12s, color 0.12s;
}
.pa-link:hover { text-decoration-color: var(--pa-accent); }

.pa-spin { animation: pa-spin 0.8s linear infinite; }
@keyframes pa-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

/* ──────────────────────────────────────────────────────────────────────
 * Prompts tab
 * ──────────────────────────────────────────────────────────────────── */
.pa-prompts-fields {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.pa-prompts-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pa-prompts-field__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.pa-prompts-field__label {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--pa-ink);
  letter-spacing: -0.005em;
}

.pa-prompts-field__purpose {
  margin-top: 2px;
  font-size: 12px;
  color: var(--pa-ink-3);
  line-height: 1.5;
  max-width: 560px;
}

.pa-prompts-field__input {
  width: 100%;
  padding: 10px 12px;
  font-family: var(--pa-sans);
  font-size: 13px;
  line-height: 1.55;
  color: var(--pa-ink);
  background: var(--pa-bg);
  border: 1px solid var(--pa-line-2);
  border-radius: var(--pa-r-sm);
  outline: none;
  resize: vertical;
  transition: border-color 0.12s;
}
.pa-prompts-field__input:focus { border-color: var(--pa-accent); }
.pa-prompts-field__input:disabled { background: var(--pa-soft); color: var(--pa-ink-3); }

.pa-prompts-field__foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11.5px;
  color: var(--pa-ink-4);
}

.pa-prompts-field__foot-status .pa-meta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.pa-prompts-field__count.is-near { color: var(--pa-warn, #b26a00); }
.pa-prompts-field__count.is-over { color: var(--pa-err); font-weight: 600; }

.pa-prompts-field__examples {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  background: var(--pa-soft);
  border-radius: var(--pa-r-sm);
}

.pa-prompts-field__examples-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  color: var(--pa-ink-3);
  margin-bottom: 2px;
}

.pa-prompts-field__example {
  text-align: left;
  font: inherit;
  font-size: 12.5px;
  line-height: 1.45;
  color: var(--pa-ink-2);
  background: var(--pa-bg);
  border: 1px solid var(--pa-line-2);
  border-radius: var(--pa-r-sm);
  padding: 8px 10px;
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s;
}
.pa-prompts-field__example:hover { background: var(--pa-hover); border-color: var(--pa-line-3); }

.pa-prompts-field--readonly { padding: 12px 0; border-top: 1px dashed var(--pa-line); }
.pa-prompts-field--readonly:first-child { border-top: none; padding-top: 0; }

.pa-prompts-field__readonly-body {
  margin-top: 6px;
  padding: 10px 12px;
  background: var(--pa-soft);
  border-radius: var(--pa-r-sm);
  font-family: var(--pa-sans);
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--pa-ink-2);
  white-space: pre-wrap;
}

.pa-prompts-field__inherited {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  background: var(--pa-soft);
  border: 1px dashed var(--pa-line-2);
  border-radius: var(--pa-r-sm);
}

.pa-prompts-field__inherited-body {
  font-family: var(--pa-sans);
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--pa-ink-2);
  white-space: pre-wrap;
}

.pa-prompts-field__inherited-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.pa-prompts-preview {
  margin: 0;
  padding: 14px 16px;
  background: var(--pa-soft);
  border-radius: var(--pa-r-sm);
  font-family: var(--pa-mono);
  font-size: 12px;
  line-height: 1.55;
  color: var(--pa-ink-2);
  white-space: pre-wrap;
  overflow-x: auto;
}

/* ──────────────────────────────────────────────────────────────────────
 * ICP weighting tab
 * ──────────────────────────────────────────────────────────────────── */
.pa-icp-toolbar {
  display: flex;
  gap: 6px;
  align-items: center;
}

.pa-icp-group {
  margin-top: 22px;
  padding-top: 14px;
  border-top: 1px solid var(--pa-line);
}

.pa-icp-group:first-of-type {
  border-top: none;
  padding-top: 8px;
}

.pa-icp-group__head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 10px;
}

.pa-icp-group__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--pa-ink);
  letter-spacing: -0.005em;
}

.pa-icp-group__meta {
  font-size: 11.5px;
  color: var(--pa-ink-3);
}

.pa-icp-rows {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pa-icp-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  align-items: center;
  padding: 10px 0;
  border-top: 1px dashed transparent;
}

.pa-icp-row + .pa-icp-row {
  border-top-color: var(--pa-line);
}

.pa-icp-row__main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.pa-icp-row__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--pa-ink);
}

.pa-icp-row__edited {
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--pa-accent);
  padding: 2px 6px;
  border: 1px solid var(--pa-accent);
  border-radius: 999px;
}

.pa-icp-row__desc {
  font-size: 12px;
  color: var(--pa-ink-3);
  line-height: 1.5;
}

.pa-icp-row__control {
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

.pa-icp-row__input {
  width: 70px;
  padding: 6px 8px;
  font-family: var(--pa-mono);
  font-size: 12.5px;
  color: var(--pa-ink);
  background: var(--pa-bg);
  border: 1px solid var(--pa-line-2);
  border-radius: var(--pa-r-sm);
  outline: none;
  text-align: right;
  transition: border-color 0.12s;
}

.pa-icp-row__input:focus { border-color: var(--pa-accent); }
.pa-icp-row__input:disabled { background: var(--pa-soft); color: var(--pa-ink-3); }

.pa-icp-row__pct {
  min-width: 36px;
  text-align: right;
  font-size: 12px;
  color: var(--pa-ink-3);
}

.pa-icp-row__default {
  font-size: 11px;
  color: var(--pa-ink-4);
}

.pa-icp-total {
  margin-top: 20px;
  padding: 14px 16px;
  border: 1px solid var(--pa-line);
  border-radius: var(--pa-r-md);
  background: var(--pa-panel);
}

.pa-icp-total--over { border-color: var(--pa-err); background: #fdf1ef; }
.pa-icp-total--under { border-color: var(--pa-warn-bd, #f1c97a); background: #fef9ef; }
.pa-icp-total--ok { border-color: var(--pa-line-2); }

.pa-icp-total__bar {
  position: relative;
  height: 6px;
  background: var(--pa-soft);
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 10px;
}

.pa-icp-total__fill {
  position: absolute;
  inset: 0 auto 0 0;
  background: var(--pa-accent);
  border-radius: 999px;
  transition: width 0.16s ease-out, background 0.16s ease-out;
}

.pa-icp-total--over .pa-icp-total__fill { background: var(--pa-err); }
.pa-icp-total--under .pa-icp-total__fill { background: var(--pa-warn, #b26a00); }

.pa-icp-total__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.pa-icp-total__sum {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: var(--pa-ink-3);
}

.pa-icp-total__num {
  font-size: 16px;
  font-weight: 600;
  color: var(--pa-ink);
}

.pa-icp-total__target {
  font-size: 12.5px;
  color: var(--pa-ink-4);
}

.pa-icp-total__actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.pa-icp-total--readonly {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 20px;
  padding: 10px 14px;
  background: var(--pa-soft);
  border-radius: var(--pa-r-sm);
}

.pa-icp-inherit-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
  padding: 12px 16px;
  background: var(--pa-soft);
  border: 1px dashed var(--pa-line-2);
  border-radius: var(--pa-r-sm);
}
`;

export default prospectingAgentStyles;
